// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RGHa","selected":"styles_selected__dEH9E"};